export default {
  

  setServiceFormState(state, {formType, filterType, filterValue, inputId,value}) {
    let formFilters = state.servicesForm[formType].filters;
    
    let currFilter = formFilters.find((filter)=>{
       return filter.value === filterValue   
    })


    switch(filterType) {
      case 'input':{
        currFilter.answer = value
        break;
      }

      case 'image':{
        currFilter.media = value
        break;
      }

      case 'radio':{
        currFilter.options.forEach((option)=>{
          if(option.id === inputId) {
            option.active = true
          }else{
            option.active = false
          } 
        })
        break;
      }

      case 'box':{
        currFilter.options.forEach((option)=>{
          if(currFilter?.multiselect){
            if(option.id === inputId) {
              option.active = !option.active
            }
          }else{
            if(option.id === inputId) {
              option.active = !option.active
            }else{
              option.active = false
            } 
          }
        })
        break;
      }

      case 'select':{
        currFilter.options.forEach((option)=>{
          if(option.id === inputId) {
            option.active = !option.active
          } 
        })
        break;
      }

      default: 
        break;
    }
   
  },


  setUserId(state, userId) {
    state.userId = userId
  },

  setMedia(state, data) {
    state.media[data.type] = [ ...state.media[data.type], data.media ]
  },

  removeMedia(state, data) {
    state.media[data.type] = state.media[data.type].filter(media => media.uuid !== data.uuid)
  },
  resetMedia(state, module) {
    state.media[module] = [];
  },
  addService(state, serviceName) {

    state.selectedServices.push(serviceName)
  },

  removeService(state, serviceName) {
    state.selectedServices = state.selectedServices.filter(service => service !== serviceName)
  },
  
  /**
   * WHEN ONE INPUT WILL UPDATE OPTIONS OF OTHER INPUTS 
   * FOR EXAMPLE: IF SELECTING A CATEGORY, THE SUBCATEGORY OPTIONS WILL BE UPDATED 
   */
  updateMultiSelection(state, {formType, filterType, filterValue, inputId,value,subSelectKey}){
    let formFilters = state.servicesForm[formType].filters;
    
    let currFilter = formFilters.find((filter)=>{
       return filter.value === filterValue   
    })

    const activeOption = currFilter.options.find((option)=> !!option.active)

    let subSelectField = formFilters.find((filter)=>{
      return filter.value === subSelectKey   
   }) 

   if(activeOption 
      && subSelectField?.allOptions 
      && subSelectField?.allOptions[activeOption?.value] ){

      subSelectField.options = subSelectField?.allOptions[activeOption?.value]
   
    }

  },

  clearServiceState(state, serviceName) {
    let formFilters = state.servicesForm[serviceName].filters;

    formFilters.forEach((filter)=>{
      if(filter.type === 'input') {
        filter.answer = ''
      }else if(filter.type==='image'){
        filter.media = null
      }else if(filter.type==='disclaimer'){
        // do nothing
      }else{
        filter.options?.forEach((option)=>{
          option.active = false
        })
      }
    })


  }
}